<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="Image3DComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="50"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">
			<rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
			<sync-drag :target="this" />

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-Image3DComponent'>
        <img src="static/images/icons/link.svg"
                           v-tooltip="{content:$t('ct-option-link'),  class: 'tooltip-custom'}"
                           class="svg-icon normal-action"
                           @click="linkElement"/>
      </options-element-bar>

      <div class="sitebuilder-element image3D-container"
           :class="{'preview': preview}"
           role="img" aria-label=""
           :style="{'background-image': `url(${internal_config.src})`, opacity: opacity, 'border-radius': radius, border : border}" ref="image"
           @mousemove.self="mouseMove"
           @mouseout.self="mouseout"
           @mousedown.self="mousedown"
           @mouseup.self="mouseup"
      >
        <img :src="this.internal_config.src" class="sitebuilder-element">
      </div>
    </vue-draggable-resizable>
  </div>
</template>

<script>

	import ImageData from './Model';
  import OptionsElementBar from "../OptionsElementBar";
  import MixinComponents from "../../../../js/mixins/MixinComponents";

  export default {
    name: 'Image3DComponent',
    props: ['config', 'src', 'id', 'preview'],
    mixins: [MixinComponents],
    components: {
      OptionsElementBar,
    },
    computed: {
      opacity() {
        return this.internal_config.opacity;
      },
    },
    data() {
      return ImageData.data();
    },
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },

    methods: {
      animation() {
        return true;
      },
      onResize: function (x, y, width, height) {
        this.internal_config.width = width + 'px';
        this.internal_config.height = height + 'px';

        this.$refs.resourcesData.setValuesData(this);
      },
      linkElement: function () {
        this.$root.$emit('linkComponentShow', this);
      },
      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },
      build(config) {
        this.internal_config = config;
      },
      mouseout() {
        if (!this.preview) {
          return
        }

        let el = this.$refs.image
        el.style.transform = 'perspective(500px) scale(1) rotateX(0) rotateY(0)'
      },
      mousedown() {
        if (!this.preview) {
          return
        }

        let el = this.$refs.image
        el.style.transform = 'perspective(500px) scale(0.9) rotateX(0) rotateY(0)'

      },
      mouseup() {
        if (!this.preview) {
          return
        }

        let el = this.$refs.image
        el.style.transform = 'perspective(500px) scale(1.1) rotateX(0) rotateY(0)'
      },
      mouseMove(e) {
        if (!this.preview) {
          return
        }

        let el = this.$refs.image

        const height = el.clientHeight
        const width = el.clientWidth
        var xVal = e.layerX
        var yVal = e.layerY

        if(xVal < 0){
          xVal = -1*xVal
          if(xVal > 400) {
            xVal = xVal /2
          }
        }

        if(yVal < 0 ){
          yVal = -1*yVal
          if(yVal > 400) {
            yVal = yVal /2
          }
        }

        const yRotation = 20 * ((xVal - width / 2) / width)
        const xRotation = -20 * ((yVal - height / 2) / height)
        const string = 'perspective(500px) scale(1.1) rotateX(' + xRotation + 'deg) rotateY(' + yRotation + 'deg)'

        el.style.transform = string
      },

      style() {
        var style = `width: ${this.internal_config.width};
                     height: auto;
                     z-index: ${this.internal_config.zIndex};
                     max-width: ${this.internal_config.maxWidth};
                     margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     left:  ${this.internal_config.left};
                     top: ${this.internal_config.top}`;
        return style;
      },

      styleResize() {
        return `{width: ${this.internal_config.width}, height: auto}`;
      },

      hover() {
        this.$emit('highlightHover', {name: this.name, posicao: this.$refs.image.getBoundingClientRect()});
      },
    },

    created() {
      this.build(this.$props.config);

      this.internal_config = window.mergeRecursive(this.props, this.$props.config);
    },

    mounted() {

      if (this.$props.preview) {
        this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

        // $(this.$refs.image).atvImg();
      }

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });
      if (objIds.includes(this.id)) {
        this.id = Date.now() + parseInt(Math.random() * 10000);
      }

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });

      // this.$refs.resourcesData.setValuesData(this);
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {
    width: 100%;
    height: auto;
  }

  .resizable.vdr {
    width: 100% !important;
    height: auto !important;
    left: 0 !important;
    top: 0 !important;
  }

  .image3D-container {
    display: block;
    height: 100%;
    width: 100%;
    margin: 0 auto;
    transition: box-shadow 0.1s, transform 0.1s;

    background-size: 100%;
    background-repeat: no-repeat;
  }

  .image3D-container.preview:hover {
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.6);
    cursor: pointer;
  }

  .image3D-container img {
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Image3D/Image3D.vue